// 拗音数据：https://docs.qq.com/sheet/DUENveEhLUUZJckRP?tab=rtczqf&_t=1617155416916

/* eslint-disable */

const hard = {
  'column': ['や', 'ゆ', 'よ'],
  'row': {
    'key': ['き', 'し', 'ち', 'に', 'ひ', 'み', 'り', 'ぎ', 'じ', 'び', 'ぴ'],
    'value': [
      [
        {
          'hiragana': 'きゃ', // 平假名
          'katakana': 'キャ', // 片假名
          'romaji': 'kya', // 罗马音
        },
        {
          'hiragana': 'きゅ', // 平假名
          'katakana': 'キュ', // 片假名
          'romaji': 'kyu', // 罗马音
        },
        {
          'hiragana': 'きょ', // 平假名
          'katakana': 'キョ', // 片假名
          'romaji': 'kyo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'しゃ', // 平假名
          'katakana': 'シャ', // 片假名
          'romaji': 'sha', // 罗马音
        },
        {
          'hiragana': 'しゅ', // 平假名
          'katakana': 'シュ', // 片假名
          'romaji': 'shu', // 罗马音
        },
        {
          'hiragana': 'しょ', // 平假名
          'katakana': 'ショ', // 片假名
          'romaji': 'sho', // 罗马音
        },

      ],
      [
        {
          'hiragana': 'ちゃ', // 平假名
          'katakana': 'チャ', // 片假名
          'romaji': 'cha', // 罗马音
        },
        {
          'hiragana': 'ちゅ', // 平假名
          'katakana': 'チュ', // 片假名
          'romaji': 'chu', // 罗马音
        },
        {
          'hiragana': 'ちょ', // 平假名
          'katakana': 'チョ', // 片假名
          'romaji': 'cho', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'にゃ', // 平假名
          'katakana': 'ニャ', // 片假名
          'romaji': 'nya', // 罗马音
        },
        {
          'hiragana': 'にゅ', // 平假名
          'katakana': 'ニュ', // 片假名
          'romaji': 'nyu', // 罗马音
        },
        {
          'hiragana': 'にょ', // 平假名
          'katakana': 'ニョ', // 片假名
          'romaji': 'nyo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'ひゃ', // 平假名
          'katakana': 'ヒャ', // 片假名
          'romaji': 'hya', // 罗马音
        },
        {
          'hiragana': 'ひゅ', // 平假名
          'katakana': 'ヒュ', // 片假名
          'romaji': 'hyu', // 罗马音
        },
        {
          'hiragana': 'ひょ', // 平假名
          'katakana': 'ヒョ', // 片假名
          'romaji': 'hyo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'みゃ', // 平假名
          'katakana': 'ミャ', // 片假名
          'romaji': 'mya', // 罗马音
        },
        {
          'hiragana': 'みゅ', // 平假名
          'katakana': 'ミュ', // 片假名
          'romaji': 'myu', // 罗马音
        },
        {
          'hiragana': 'みょ', // 平假名
          'katakana': 'ミョ', // 片假名
          'romaji': 'myo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'りゃ', // 平假名
          'katakana': 'リャ', // 片假名
          'romaji': 'rya', // 罗马音
        },
        {
          'hiragana': 'りゅ', // 平假名
          'katakana': 'リュ', // 片假名
          'romaji': 'ryu', // 罗马音
        },
        {
          'hiragana': 'りょ', // 平假名
          'katakana': 'リョ', // 片假名
          'romaji': 'ryo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'ぎゃ', // 平假名
          'katakana': 'ギャ', // 片假名
          'romaji': 'gya', // 罗马音
        },
        {
          'hiragana': 'ぎゅ', // 平假名
          'katakana': 'ギュ', // 片假名
          'romaji': 'gyu', // 罗马音
        },
        {
          'hiragana': 'ぎょ', // 平假名
          'katakana': 'ギョ', // 片假名
          'romaji': 'gyo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'じゃ', // 平假名
          'katakana': 'ジャ', // 片假名
          'romaji': 'ja', // 罗马音
        },
        {
          'hiragana': 'じゅ', // 平假名
          'katakana': 'ジュ', // 片假名
          'romaji': 'ju', // 罗马音
        },
        {
          'hiragana': 'じょ', // 平假名
          'katakana': 'ジョ', // 片假名
          'romaji': 'jo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'びゃ', // 平假名
          'katakana': 'ビャ', // 片假名
          'romaji': 'bya', // 罗马音
        },
        {
          'hiragana': 'びゅ', // 平假名
          'katakana': 'ビュ', // 片假名
          'romaji': 'byu', // 罗马音
        },
        {
          'hiragana': 'びょ', // 平假名
          'katakana': 'ビョ', // 片假名
          'romaji': 'byo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'ぴゃ', // 平假名
          'katakana': 'ピャ', // 片假名
          'romaji': 'pya', // 罗马音
        },
        {
          'hiragana': 'ぴゅ', // 平假名
          'katakana': 'ピュ', // 片假名
          'romaji': 'pyu', // 罗马音
        },
        {
          'hiragana': 'ぴょ', // 平假名
          'katakana': 'ピョ', // 片假名
          'romaji': 'pyo', // 罗马音
        },
      ],
    ],
  }
};

export default hard;
